export enum LoginPaths {
  loginForm = '',
  twoFactorForm = 'twofactorform',
  loginResetPassword = 'resetpassword',
  loginRecoveryPassword = 'recoverypassword'
}
